import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { AuthStorageService, BaseSiteService, OccEndpointsService, UserIdService } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError, publishReplay, refCount, retry, take } from 'rxjs/operators';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from 'src/app/spartacus/features/asm/asm-constant';
import { environment } from 'src/environments/environment';
import { StorageService } from '../storage/storage.service';

export interface GetB2BUnitAddPayload {
  fields?: string;
}

export interface GetDynamicFormForCountry {
  fields?: string;
  countryCode?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ShimanoDynamicFormService {
  baseSite$: Observable<string> = this.baseService.getActive();
  userCurrent$: Observable<string> = this.auth.getUserId();
  occUrl = this.meta.getTag('name=occ-backend-base-url');
  url = `${this.occUrl.content}${environment.prefix}${this.baseSiteId}`;
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);

  cacheWindowTime = 3600000;
  private cachedDynamicForm$: any = {};

  constructor(
    private meta: Meta,
    protected http: HttpClient,
    protected auth: UserIdService,
    protected authStorageService: AuthStorageService,
    protected baseService: BaseSiteService,
    private occEndpointsService: OccEndpointsService,
    private storageService: StorageService
  ) {}
  get baseSiteId(): string {
    let baseSiteId: string;
    this.baseSite$.pipe(take(1)).subscribe((baseSiteData) => (baseSiteId = baseSiteData));
    return baseSiteId;
  }

  get userCurrent(): string {
    let userCurrent: string;
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }

  getDynamicForm(formId: string, payload: GetDynamicFormForCountry): Observable<any> {
    const asmQuery = this.asmEnabled ? `?asmUser=${this.userCurrent}` : '';
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    let params: any;
    if (formId !== 'CHANGE_BILLING_ADDRESS') {
      params = new HttpParams().set('fields', payload.fields as any).set('countryCode', payload.countryCode as any);
    } else {
      params = new HttpParams().set('fields', payload.fields as any);
    }

    if (!this.cachedDynamicForm$[formId]) {
      this.cachedDynamicForm$[formId] = this.http
        .get(this.occEndpointsService.buildUrl(`/dynamicForms/${formId}`), { params, headers })
        .pipe(
          publishReplay(1, this.cacheWindowTime),
          refCount(),
          take(1),
          catchError((error: any) => {
            return throwError(error);
          })
        );
    }
    return this.cachedDynamicForm$[formId];
  }

  getDynamicFormForCountry(formId: string, payload: GetDynamicFormForCountry): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const params = new HttpParams().set('fields', payload.fields as any).set('countryCode', payload.countryCode as any);
    return this.http
      .get(this.occEndpointsService.buildUrl(`/dynamicForms/${formId}`), {
        params,
        headers,
      })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  getRegions(countryCode: string): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .get(this.occEndpointsService.buildUrl(`/dynamicForms/${countryCode}/regions`), {
        headers,
      })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  getB2BUnitAddresses(payload: GetB2BUnitAddPayload): Observable<any> {
    const asmQuery = this.asmEnabled ? `?asmUser=${this.userCurrent}` : '';
    const params = new HttpParams().set('fields', payload.fields);
    return this.http
      .get(this.occEndpointsService.buildUrl(`/dynamicForms/${this.userCurrent}/unitAddresses`), {
        params,
        headers: this.headers,
      })
      .pipe(retry(1), catchError(this.errorHandler));
  }

  // Error handling
  errorHandler(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
  errorHandl(errorHandl: any): any {
    throw new Error('Method not implemented.');
  }
}
